module.exports = __webpack_public_path__ + "img/arrow.c35ce641.svg";